// @ts-nocheck
import { CPF_CNPJ as checkCpfCnpj } from '@lbca/validations';
import { replaceAllNotAlphanumericTextCursor } from '../replaceWithCursorPosition';

export class MaskCpfCnpj {
  private maxLength = 20;

  constructor(_view: any, public assets: any) {}

  public removeMask(value: string, cursorPosition): { newValue; newCursorPosition } {
    const { newValue, newCursorPosition } = replaceAllNotAlphanumericTextCursor(value, cursorPosition);

    if (newValue.length > 20) {
      return {
        newValue: newValue.substr(0, this.maxLength),
        newCursorPosition: newCursorPosition >= this.maxLength ? this.maxLength : newCursorPosition,
      };
    }

    return { newValue, newCursorPosition };
  }

  public setMask(
    value: string | number,
    cursorPosition
  ): { formatedValue; formatedCursorPosition } {
    try {
      const param = typeof value === 'number' ? String(value) : value;
      const cleanValue = param.replace(/[^A-Z0-9]/g, '');
      const lengthCleanValue = cleanValue.length;
      let auxCursorPosition = cursorPosition;
      let formatedValue;

      if (lengthCleanValue > 11) {
        formatedValue = param
          .replace(/[^A-Z0-9]/g, '')
          .replace(/([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
          .replace(/([A-Z0-9]{3})([A-Z0-9])/, '$1.$2')
          .replace(/([A-Z0-9]{3})([A-Z0-9])/, '$1/$2')
          .replace(/([A-Z0-9]{4})(\d)/, '$1-$2')
          .replace(/(-\d{1,2})\d+?$/, '$1');

        if (lengthCleanValue > 2) auxCursorPosition++;
        if (lengthCleanValue > 5) auxCursorPosition++;
        if (lengthCleanValue > 8) auxCursorPosition++;
        if (lengthCleanValue > 12) auxCursorPosition++;
      } else {
        formatedValue = param
          .replace(/[^A-Z0-9]/g, '')
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d)/, '$1-$2')
          .replace(/(-\d{2})\d+?$/, '$1');

        if (lengthCleanValue > 3) auxCursorPosition++;
        if (lengthCleanValue > 6) auxCursorPosition++;
        if (lengthCleanValue > 9) auxCursorPosition++;
      }

      const quantityPoints = formatedValue.slice(0, auxCursorPosition).replace(/[^A-Z0-9]/g, '').length;

      return { formatedValue, formatedCursorPosition: cursorPosition + quantityPoints };
    } catch (err) {
      console.error('Error: ', err);
      return { formatedValue: value, formatedCursorPosition: cursorPosition };
    }
  }

  public validate(value) {
    const { newValue: valueWithoutMask } = replaceAllNotAlphanumericTextCursor(value, value.length);
    return checkCpfCnpj(valueWithoutMask);
  }

  public getMaskErrors(value) {
    return [this.assets.labels.feedbacks.masks['CPF-CNPJ']];
  }
}
